import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  delete_icon,
  edit_icon,
  eye_icon,
  password_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { admin_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import FavoriteIcon from "@mui/icons-material/Favorite";
import {
  useAddDeviceMutation,
  useDeviceListMutation,
  useLazyDeviceStatusQuery,
  useLazyManualTriggerQuery,
  useLazyViewDeviceQuery,
  useUpdateDeviceMutation,
} from "../redux/api/api";
import apiRequest from "../redux/api/apiRequest";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import CustomSearchSelect from "../../components/Searchbox/CustomSearch";
import CommonLoader from "../../components/CommonLoader";

const DeviceList = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [list, setList] = useState([]);
  const [pagination, setPagination] = useState("");
  const [loader, setLoader] = useState(false);
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [deviceId, setDeviceId] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [deviceLat, setDeviceLat] = useState("");
  const [company, setCompany] = useState([]);
  const [deviceLng, setDeviceLng] = useState("");
  const [assigned, setAssigned] = useState("");
  const [assignedcompany, setAssignedCompany] = useState("");
  const [search, setSearch] = useState("");
  const [id, setId] = useState("");
  const [error, setError] = useState(false);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [userData, setUserData] = useState(null);
  const [change, setChange] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState();
  const [fullLoader, setFullLoader] = useState(false);

  const [DeviceStatus] = useLazyDeviceStatusQuery();
  const [deviceList] = useDeviceListMutation();
  const [addDevice] = useAddDeviceMutation();
  const [updateDevice] = useUpdateDeviceMutation();
  const [viewDevice] = useLazyViewDeviceQuery();
  const [manualTriggerApi] = useLazyManualTriggerQuery();

  const [type, setType] = useState("");

  const handleStatus = async (id) => {
    const res = await apiRequest(DeviceStatus, id);
    if (res?.status == "success") {
      toast.success(res?.message);
      getList();
    }
  };

  const filterList = (list, val) => {
    let uppercaseval = val?.toLocaleUpperCase();
    let data = list?.filter((data) => {
      if (
        data?.name?.toLocaleUpperCase()?.indexOf(uppercaseval) >= 0 ||
        data?.email?.toLocaleUpperCase()?.indexOf(uppercaseval) >= 0
      ) {
        return true;
      }
    });
    return data;
  };

  const getList = async (search) => {
    const formdata = new FormData();
    formdata.append("rows", 10);
    formdata.append("page", page);
    formdata.append("search", search ? search : "");
    formdata.append("order", "desc");
    setFullLoader(true);
    const res = await apiRequest(deviceList, formdata);
    setFullLoader(false);
    if (res?.status == "success") {
      setList(res?.lists);
      setCount(res?.pagination_meta);
      setPagination(res?.pagination_meta);
    }
  };

  useEffect(() => {
    if (givenpermissions?.includes("CAN-List-DEVICES")) {
      getList();
    }
  }, [page]);

  const Add = async () => {
    if (!deviceName || !deviceId) {
      setError(true);
      return;
    }
    console.log("submit func", assigned);
    if (type == "edit" && !assigned) {
      setError(true);
      return;
    }
    setError(false);
    const formdata = new FormData();
    formdata.append("name", deviceName);
    formdata.append("device_code", deviceId);
    if (type == "edit") {
      // formdata.append("latitude", deviceLat);
      // formdata.append("longitude", deviceLng);
      formdata.append("device_id", id);
      formdata.append("company_id", assigned);
      // formdata.append("user_id", assigned);
    }
    setLoader(true);
    const res = await apiRequest(
      type == "edit" ? updateDevice : addDevice,
      formdata,
    );
    setLoader(false);
    if (res?.status == "success") {
      toast.success(res?.message);
      setType("");
      setPopup(false);
      getList();
    } else {
      toast.error("Error");
    }
  };

  const View = async (id, type) => {
    setType(type);
    setDeviceId("");
    setDeviceName("");
    setAssigned("");
    setId(id);
    setLoading(true);
    const res = await apiRequest(viewDevice, id);
    setLoading(false);
    if (res?.status == "success") {
      let data = res?.primary_company;
      let id = res?.role_data?.assigned_company?.id;
      setCompany(data);
      let company = data?.find((item) => item?.id == id);
      setAssignedCompany(company);
    }
    if (res?.status == "success") {
      let data = res?.role_data;
      setDeviceName(data?.device_name);
      setDeviceId(data?.device_code);
      setDeviceLat(data?.latitude);
      setDeviceLng(data?.longitude);
      setAssigned(data?.assigned_company?.id);
      setSearch(data?.assigned?.name);
      setUsers(res?.primary_users);
      setPopup(true);
    }
  };

  const manualTrigger = (id) => {
    setLoading(true);
    manualTriggerApi(id)
      .unwrap()
      .then((res) => {
        setLoading(false);
        if (res?.status == "success") {
          toast.success(res?.message);
        } else {
          toast.error(res?.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
      });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Device Name",
        accessor: "device_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Device ID",
        accessor: "device_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Company",
        accessor: "assigned_company.name",
        Cell: ({ value, row }) => {
          return (
            <p
              onClick={() => {
                setUserData(row.original.assigned);
              }}
              className="pointerView assigned text-decoration-underline"
            >
              {value ? value : "--"}
            </p>
          );
        },
      },
      {
        Header: "Location",
        accessor: "location",
        Cell: ({ value, row }) => {
          return <p>{value ? value : "--"}</p>;
        },
      },
      {
        Header: "View Members",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  navigate("/members-list", {
                    state: { data: row.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Device Report",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  navigate("/report", {
                    state: { data: row.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Notification Report",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  navigate("/notificationreport", {
                    state: { data: row.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Device Status",
        accessor: "device_status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button className={`border-0 toggle-btn cust-btn `}>
                {value == 1 ? (
                  <div>
                    <FavoriteIcon className="green" />
                  </div>
                ) : (
                  <div>
                    <FavoriteIcon className="red" />
                  </div>
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: " Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (givenpermissions?.includes("CAN-Status-DEVICES")) {
                    handleStatus(row.original.id);
                  }
                }}
                className={`border-0 ms-2 cust-btn ${
                  givenpermissions?.includes("CAN-Status-DEVICES")
                    ? ""
                    : "opacity-50"
                }`}
              >
                {value == 1 ? (
                  <img className="toggle-btn" src={toggle_on} />
                ) : (
                  <img className="toggle-btn" src={toggle_off} />
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {givenpermissions?.includes("CAN-View-DEVICES") && (
                  <button
                    onClick={() => {
                      View(row.original.id, "view");
                      setType("view");
                    }}
                    className="cust-btn "
                    disabled={loading}
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
                {givenpermissions?.includes("CAN-Edit-DEVICES") && (
                  <button
                    type="edit"
                    onClick={() => {
                      View(row.original.id, "edit");
                      setType("edit");
                    }}
                    className="cust-btn "
                    disabled={loading}
                  >
                    <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page],
  );

  return (
    <div className="dashRightView home_section">
      {loading && (
        <div
          style={{ zIndex: 1500, position: "fixed", top: "45%", left: "49%" }}
        >
          <Spinner animation="border" className="primary" />
        </div>
      )}
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
          Device List
        </h2>
        {givenpermissions?.includes("CAN-Add-DEVICES") && (
          <button
            onClick={() => {
              setPopup(true);
              setDeviceId("");
              setDeviceName("");
              setAssigned("");
              setDeviceLat("");
              setDeviceLng("");
              setType("add");
            }}
            className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
          >
            {" "}
            + Add Device{" "}
          </button>
        )}
      </div>
      <div className="d-flex ac-jb my-4 ">
        <div className="d-flex">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  mb-0 ">
            Total Count :
          </h4>
          <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-0 ms-2">
            {count?.total}
          </h4>
        </div>
        <div className="d-flex">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  me-3 mb-0 ms-3 mt-2">
            Search
          </h4>
          <input
            type="text"
            className="input-pop ps-2"
            placeholder=" Search"
            onChange={(e) => {
              getList(e.target.value);
            }}
          />
        </div>
        {/* <div className="input-pop ms-2">
          <CustomSearchSelect
            // options={cities}
            // value={selectedCityId}
            // locationLoader={locationLoader}
            // onChange={(value) => {
            //     setSelectedCityId(value);
            //     requestList(1, fromdate, toDate, selectedPropertyId, value, search);
            // }}
            placeholder="Select Company"
            width="200px"

          />
        </div> */}
      </div>
      {popup && (
        <div className="popup-design">
          <div className="popup">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                {type == "edit"
                  ? "Edit Device"
                  : type == "view"
                    ? "View Device"
                    : "Add Device"}
              </h2>
              <button
                onClick={() => {
                  setPopup(false);
                  setType("");
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Device Name<span className="text-danger">*</span>
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder=" Name"
              onChange={(e) => {
                setDeviceName(e.target.value);
              }}
              value={deviceName}
              disabled={type == "view" ? true : false}
            />
            {error && !deviceName && <p className="err">Enter Device Name</p>}

            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Device ID<span className="text-danger">*</span>
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Device ID"
              onChange={(e) => {
                setDeviceId(e.target.value);
              }}
              value={deviceId}
              disabled={type == "view" ? true : false}
            />
            {error && !deviceId && <p className="err">Enter Device ID</p>}

            {type == "edit" ? (
              // || (type == 'view' && assigned) ?
              <div className="position-relative">
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Company Name<span className="text-danger">*</span>
                </h4>
                <select
                  disabled={type == "view" ? true : false}
                  value={assigned}
                  onChange={(e) => setAssigned(e.target.value)}
                  className={`${
                    type == "view" ? "hide-select" : ""
                  } input-pop ps-2 w-100`}
                  name=""
                  id=""
                >
                  <option>-- Select Company --</option>
                  {company.map((item) => {
                    return (
                      <option value={item?.id}>
                        {item?.name} - {item?.location_info?.name}
                      </option>
                    );
                  })}
                </select>
                {error && !assigned && (
                  <p className="err">Enter Company Name and Location</p>
                )}
              </div>
            ) : type == "view" && assigned ? (
              <div className="position-relative">
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Company Name<span className="text-danger">*</span>
                </h4>
                <input
                  type="text"
                  className="input-pop ps-2 w-100"
                  placeholder="Device ID"
                  onChange={(e) => {
                    setDeviceId(e.target.value);
                  }}
                  value={`${assignedcompany?.name} - ${assignedcompany?.location_info?.name}`}
                  disabled={type == "view" ? true : false}
                />
              </div>
            ) : null}
            {/* {(type == "edit" || type == "view") && (
              <>
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Device Latitude
                </h4>
                <input
                  type="text"
                  className="input-pop ps-2 w-100"
                  placeholder="Device Latitude"
                  onChange={(e) => {
                    setDeviceLat(e.target.value);
                  }}
                  value={deviceLat}
                  disabled={type == "view" ? true : false}
                />
                {error && !deviceLat && (
                  <p className="err">Enter Device Latitude</p>
                )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Device Longitude
                </h4>

                <input
                  type="text"
                  className="input-pop ps-2 w-100"
                  placeholder="Device Longitude"
                  onChange={(e) => {
                    setDeviceLng(e.target.value);
                  }}
                  value={deviceLng}
                  disabled={type == "view" ? true : false}
                />
                {error && !deviceLng && (
                  <p className="err">Enter Device Longitude</p>
                )}
                <div className="position-relative">
                  <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                    Assigned To
                  </h4>
                  <input
                    type="text"
                    className="input-pop ps-2 w-100"
                    placeholder="Assigned"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    value={search}
                    onFocus={() => {
                      setShow(true);
                    }}
                    disabled={type == "view" ? true : false}
                  />
                  {show && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        backgroundColor: "white",
                        height: "200px",
                        overflow: "scroll",
                        width: "100%",
                        borderwidth: "1px",
                        borderStyle: "solid",
                        borderColor: "gray",
                        borderRadius: "10px",
                        zIndex: 1000,
                      }}
                    >
                      <ui>
                        {(!search ? users : filterList(users, search))?.map(
                          (item) => {
                            return (
                              <li
                                className="pointer"
                                onClick={() => {
                                  if (assigned && assigned != item?.id) {
                                    setChange({
                                      id: item?.id,
                                      name: item?.name,
                                    });
                                  } else {
                                    setAssigned(item?.id);
                                    setSearch(item?.name);
                                  }
                                  setShow(false);
                                }}
                                style={{
                                  paddingTop: "10px",
                                  paddingBottom: "10px",
                                  borderBottom: "1px solid gray",
                                  listStyleType: "none",
                                  paddingLeft: "20px",
                                }}
                                value={item?.id}
                              >{`${item?.name}  (${item?.email})`}</li>
                            );
                          }
                        )}
                      </ui>
                    </div>
                  )}
                  {/* <select
                  name=""
                  id=""
                  className="input-pop ps-2 w-100"
                  onChange={(e) => {
                    if (assigned) {
                      setChange(e.target.value);
                    } else {
                      setAssigned(e.target.value);
                    }
                  }}
                  value={assigned}
                  disabled={type == "view" ? true : false}
                >
                  <option value={0}>-- Select --</option>
                  {users?.map((item) => {
                    return (
                      <option
                        value={item?.id}
                      >{`${item?.name}  (${item?.email})`}</option>
                    );
                  })}
                </select> */}
            {/* {error && !assigned && <p className="err">Assign The User</p>}
                </div>
              </> */}
            {/* // )} */}
            {type != "view" && (
              <div className="d-flex ac-jc mt-3">
                <button
                  onClick={() => {
                    Add();
                  }}
                  className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                >
                  {loader && (
                    <div
                      class="spinner-border spinner-border-sm "
                      role="status"
                      style={{ marginRight: "5px" }}
                    ></div>
                  )}
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {userData && (
        <div className="popup-design">
          <div className="popup">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                view User
              </h2>
              <button
                onClick={() => {
                  setUserData(null);
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Email
            </h4>
            <input
              type="email"
              className="input-pop ps-2 w-100"
              placeholder=" Email Address"
              name="email"
              value={userData?.email}
              disabled={true}
            />
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Name
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder=" Name"
              name="name"
              value={userData?.name}
              disabled={true}
            />
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Phone Number (Singapore)
            </h4>
            <input
              type="number"
              className="input-pop ps-2 w-100"
              placeholder="Phone Number (Singapore)"
              name="phone"
              value={userData?.phone}
              disabled={true}
            />
          </div>
        </div>
      )}
      {fullLoader ? (
        <CommonLoader />
      ) : (
        <Table
          columns={columns}
          data={list}
          show={true}
          pagecount={pagination}
          setPageno={setPage}
        />
      )}
      {change && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, you want to reallocate this device?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => {
                  setChange(false);
                }}
                className="no-btn"
              >
                No
              </button>
              <button
                onClick={() => {
                  setAssigned(change == 0 ? "" : change?.id);
                  setSearch(change == 0 ? "" : change?.name);
                  setChange(false);
                }}
                className="yes-btn f2"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeviceList;
